import { render, staticRenderFns } from "./promo-coupon-efective-dashboard.vue?vue&type=template&id=6ab1c98e"
import script from "./promo-coupon-efective-dashboard.vue?vue&type=script&lang=js"
export * from "./promo-coupon-efective-dashboard.vue?vue&type=script&lang=js"
import style0 from "@/assets/sass/pages/_effectivity-dashboard.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports